import { useRouter } from 'vue-router/composables'
import { superstoryTrack } from './track'
import { useHistoryStore } from './stores'

/**
 * @description Go back to the previous page, fallback to `home` page
 */
export function useGotoBack() {
  const router = useRouter()
  const historyStore = useHistoryStore()

  function gotoBack(fallback = 'home') {
    superstoryTrack('back_button_ck')
    const url = historyStore.$pop()
    if (url)
      router.replace(url)
    else
      router.replace({ name: fallback })
  }
  return gotoBack
}
